import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CollectionContent, CollectionIcon, CollectionItem, Icon, } from '../styleguide/components';
export const CollectionItemWithIcon = ({ icon, children }) => (_jsxs(CollectionItem, { children: [_jsx(CollectionIcon, Object.assign({ className: "c-collection__icon u-display--none@xs" }, { children: _jsx(Icon, { name: icon !== null && icon !== void 0 ? icon : 'email', size: 'lg', style: {
                    color: 'var(--color-primary, #76232f)',
                    width: '40px',
                    visibility: icon ? 'visible' : 'hidden',
                } }) })), _jsx(CollectionContent, { children: children })] }));
